export const BLOG_CATEGORIES: {
  title: string;
  slug: "news" | "education";
  description: string;
}[] = [
  {
    title: "News",
    slug: "news",
    description: "Updates and announcements from Watchero.",
  },
  {
    title: "Education",
    slug: "education",
    description: "Educational content about Watchero.",
  },
];

export const BLOG_AUTHORS = {
  watchero: {
    name: "watchero",
    image: "/_static/favicons/favicon-black.svg",
    lightImage: "/_static/favicons/favicon-black.svg",
    darkImage: "/_static/favicons/favicon-white.svg",
    twitter: "watchero_io",
  },
};
